const norm = (s) => String(s || "").toLowerCase();

const SUBJECTS = {
  dashboard:      (p) => p.includes("dashboard"),
  officer:        (p) => p.includes("officer") && !p.includes("contract"),
  contract:       (p) => p.includes("contract"),
  document:       (p) => p.includes("doc"),
  approval:       (p) => p.includes("approv"),
  meeting:        (p) => p.includes("meeting") && !p.includes("room"),
  "meeting-room": (p) => p.includes("room"),
  announcement:   (p) => p.includes("announc"),
  notification:   (p) => p.includes("notif"),
  report:         (p) => p.includes("report"),
  "activity-log": (p) => p.includes("activity") || p.includes("audit") || p.includes("log"),
  department:     (p) => p.includes("department") || p.includes("dept"),
  office:         (p) => p.includes("office"),
  position:       (p) => p.includes("position"),
  user:           (p) => p.includes("user"),
  role:           (p) => p.includes("role") || p.includes("permission"),
};

const ACTIONS = {
  view:   ["view", "read", "list", "get"],
  create: ["create", "add", "new", "write"],
  edit:   ["edit", "update", "modify", "write", "manage"],
  delete: ["delete", "remove", "manage"],
};

export function canDo(user, subject, action) {
  if (norm(user?.roleName).includes("admin")) return true;
  if (!Array.isArray(user?.permissions)) return true;

  const matchSubject = SUBJECTS[subject];
  if (!matchSubject) return true;

  const verbs = ACTIONS[action] || [action];
  return user.permissions
    .map(norm)
    .some((p) => matchSubject(p) && verbs.some((v) => p.includes(v)));
}

export function canAccess(user, perm) {
  if (!perm) return true;
  if (norm(user?.roleName).includes("admin")) return true;
  if (!Array.isArray(user?.permissions)) return true;

  const perms = user.permissions.map(norm);
  const subjects = Array.isArray(perm) ? perm : [perm];
  return subjects.some((s) => {
    const match = SUBJECTS[s];
    return match ? perms.some(match) : true;
  });
}

export function filterNavByPermission(items, user) {
  return items
    .map((item) => {
      if (item.children?.length) {
        const children = item.children.filter((c) => canAccess(user, c.perm));
        if (children.length === 0) return null;
        return { ...item, children };
      }
      return canAccess(user, item.perm) ? item : null;
    })
    .filter(Boolean);
}

export function firstAllowedKey(items, user) {
  const nav = filterNavByPermission(items, user);
  if (nav.length === 0) return null;
  const first = nav[0];
  return first.children?.length ? first.children[0].key : first.key;
}

export function allowedNavKeys(items, user) {
  const keys = new Set();
  filterNavByPermission(items, user).forEach((item) => {
    keys.add(item.key);
    item.children?.forEach((c) => keys.add(c.key));
  });
  return keys;
}
